"use client";

import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
    return (
        <SonnerToaster
            position="bottom-right"
            toastOptions={{
                classNames: {
                    toast: "bg-background border-border text-foreground shadow-lg",
                    success: "!bg-green-500/10 !border-green-500/20 !text-green-600",
                    error: "!bg-destructive/10 !border-destructive/20 !text-destructive",
                    info: "!bg-primary/10 !border-primary/20 !text-primary",
                },
            }}
            closeButton
            richColors
        />
    );
}
